import React from 'react';
import FormDialog from '../../../../../components/Dialog/FormDialog';
import ManageFieldsForm from './ManageFieldsForm';

const ManageFields = ({ open, close, currentBoard }) => {
  return (
    <FormDialog
      open={open}
      handleClose={close}
      title="Manage Fields"
      fullWidth={true}
      className="manage-fields-dialog"
      width={1180}
    >
      <div className="manage-fields-dialog-container">
        <ManageFieldsForm currentBoard={currentBoard} onClose={close} />
      </div>
    </FormDialog>
  );
};

export default ManageFields; 